import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
// ----------------------------------------------------------------------

const navConfig = [
  {
    title: "dashboard",
    path: "/",
    icon: <TimelineOutlinedIcon />,
  },
  {
    title: "create plate",
    path: "/create",
    icon: <AddOutlinedIcon />,
  },
  {
    title: "view all plates",
    path: "/all-plates",
    icon: <FormatListBulletedOutlinedIcon />,
  },
  {
    title: "create seed bag",
    path: "/create-seed-bag",
    icon: <AddOutlinedIcon />,
  },
  {
    title: "view all seed bags",
    path: "/all-seed-bags",
    icon: <FormatListBulletedOutlinedIcon />,
  },
];

export default navConfig;
